export default {
  select_size: 'Wähle eine Größe',
  required: 'Pflichtfeld',
  optional: 'Optional',
  select_up_to: 'Wähle bis zu {{maxCount}}',
};
